<script>
    import {drops, state} from "../stores/contracts";
    import {drops as drops_infura, useInfura, state_infura} from "../stores/contracts-infura";
    import {probabilities} from "../stores/elementData";
    import DropListing from "../components/DropListing.svelte";
    import Spinner from "../components/Spinner.svelte";
    import Window from "../components/Window.svelte";

    export let depth;
    export let toFront = ()=>{};
    export let minimise = ()=>{};
    export let openDrop = ()=>{};
    export let active = false;

    let page = 0;
    let pageSize = 20;

    let condition = "all";  //all, tokenId, element, ionCharge, elementAndIon, isIon
    let conditions = [
        {
            name: "all",
            label: "All",
        }, {
            name: "tokenId",
            label: "Atom TokenID",
        }, {
            name: "element",
            label: "Element",
        }, {
            name: "ionCharge",
            label: "Ion charge",
        }, {
            name: "elementAndIon",
            label: "Element + charge",
        }, {
            name: "isIon",
            label: "Any Ion",
        },
    ];

    let sortModes = {
        all: ["latest", "oldest", "likely", "unlikely"],

        tokenId: ["latest", "oldest", "lowest", "highest"],
        element: ["latest", "oldest", "lowest", "highest", "likely", "unlikely"],
        ionCharge: ["latest", "oldest", "lowest", "highest", "likely", "unlikely"],
        elementAndIon: ["latest", "oldest", "lowest", "highest", "likely", "unlikely"],

        isIon: ["latest", "oldest", "ionFirst", "ionLast"],
    }
    let sortMode = "latest";

    let sortedDrops = [];

    function getSortModeLabel(sortMode) {
        switch (sortMode) {
            case "latest":
                return "Newest";
            case "oldest":
                return "Oldest";
            case "likely":
                return "Most likely";
            case "unlikely":
                return "Least likely";
            case "ionFirst":
                return "Ions first";
            case "ionLast":
                return "Ions last";
            case "lowest":
                switch (condition) {
                    case "tokenId":
                        return "Lowest"
                    case "element":
                        return "Atomic Number asc."
                    case "ionCharge":
                        return "Lowest"
                    case "elementAndIon":
                        return "Atomic Number asc."
                }
                return "Lowest";
            case "highest":
                switch (condition) {
                    case "tokenId":
                        return "Highest"
                    case "element":
                        return "Atomic Number desc."
                    case "ionCharge":
                        return "Highest"
                    case "elementAndIon":
                        return "Atomic Number desc."
                }
                return "Highest";
        }
    }

    let _state;

    function dropMatchesCondition(drop,condition){
        switch(condition){
            case "all":
                return true;
            case "tokenId":
                return (drop.ionCharge === 0 &&
                        drop.isIon === false &&
                        drop.atomicNumber === 0);
            case "element":
                return (drop.ionCharge === 0 &&
                    drop.isIon === false &&
                    drop.atomicNumber !== 0);
            case "ionCharge":
                return (drop.ionCharge !== 0 &&
                    drop.isIon === false &&
                    drop.atomicNumber === 0);
            case "elementAndIon":
                return (drop.ionCharge !== 0 &&
                    drop.isIon === false &&
                    drop.atomicNumber !== 0);
            case "isIon":
                return drop.isIon;
        }
    }
    $:{
        let _drops;
        if ($useInfura) {
            _state = $state_infura;
            _drops = $drops_infura;
        } else {
            _state = $state;
            _drops = $drops;
        }

        sortedDrops = [];
        for (let tokenAddress in _drops) {
            for (let dropTokenId in _drops[tokenAddress]) {
                if(!dropMatchesCondition(_drops[tokenAddress][dropTokenId],condition)){
                    continue;
                }

                sortedDrops.push({
                    tokenAddress,
                    dropTokenId,
                    atomicNumber: _drops[tokenAddress][dropTokenId].atomicNumber,
                    ionCharge: _drops[tokenAddress][dropTokenId].ionCharge,
                    isIon: _drops[tokenAddress][dropTokenId].isIon,
                    tokenId: _drops[tokenAddress][dropTokenId].tokenId,
                    blockNumber: _drops[tokenAddress][dropTokenId].blockNumber,
                    probability: _drops[tokenAddress][dropTokenId].probability
                });
            }
        }
        switch (sortMode) {
            case "latest":
                sortedDrops.sort((a, b) => {
                    return a.blockNumber < b.blockNumber ? 1 : -1;
                });
                break;
            case "oldest":
                sortedDrops.sort((a, b) => {
                    return a.blockNumber > b.blockNumber ? 1 : -1;
                });
                break
            case "likely":
                sortedDrops.sort((a, b) => {
                    return a.probability < b.probability ? -1 : 1;
                });
                break
            case "unlikely":
                sortedDrops.sort((a, b) => {
                    return a.probability > b.probability ? -1 : 1;
                });
                break
            case "lowest":
                switch (condition) {
                    case "tokenId":
                        sortedDrops.sort((a, b) => {
                            return a.tokenId < b.tokenId ? -1 : 1;
                        });
                        break;
                    case "element":
                        sortedDrops.sort((a, b) => {
                            return a.atomicNumber < b.atomicNumber ? -1 : 1;
                        });
                        break;
                    case "ionCharge":
                        sortedDrops.sort((a, b) => {
                            return a.atomicNumber < b.atomicNumber ? -1 : 1;
                        });
                        break;
                    case "elementAndIon":
                        sortedDrops.sort((a, b) => {
                            if (a.atomicNumber === b.atomicNumber) return (a.ionCharge < b.ionCharge ? -1 : 1);
                            return (a.atomicNumber < b.atomicNumber ? -1 : 1);
                        });
                        break;

                }
                break
            case "highest":
                switch (condition) {
                    case "tokenId":
                        sortedDrops.sort((a, b) => {
                            return a.tokenId > b.tokenId ? -1 : 1;
                        });
                        break;
                    case "element":
                        sortedDrops.sort((a, b) => {
                            return a.atomicNumber > b.atomicNumber ? -1 : 1;
                        });
                        break;
                    case "ionCharge":
                        sortedDrops.sort((a, b) => {
                            return a.atomicNumber > b.atomicNumber ? -1 : 1;
                        });
                        break;
                    case "elementAndIon":
                        sortedDrops.sort((a, b) => {
                            if (a.atomicNumber === b.atomicNumber) return (a.ionCharge > b.ionCharge ? -1 : 1);
                            return (a.atomicNumber > b.atomicNumber ? -1 : 1);
                        });
                        break;

                }
                break
            case "ionFirst":
                sortedDrops.sort((a, b) => {
                    return a.isIon > b.isIon ? -1 : 1;
                });
                break;
            case "ionLast":
                sortedDrops.sort((a, b) => {
                    return a.isIon < b.isIon ? -1 : 1;
                });
                break;


        }

    }
</script>

<style>

    .controls{
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        align-content: flex-start;
        align-items: flex-start;
        gap: 10px 54px;
        margin-top: 15px;
        margin-bottom: 15px;
    }
    
    .controls .slab{
        width: 320px;
    }

    h1{
        text-align: center;
        font-size: 30px;
        font-weight: 700;
    }
    .radio-options{
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        height:60px;
    }
    .radio-options label{
        width: 50%;
    }


    h2{
        text-align: center;
        margin-bottom: 5px;
    }

    .section-drops{
        display: flex;
        flex-direction: row;
        width:100%;
        flex-wrap: wrap;
        justify-content: center;
        align-content: flex-start;
        align-items: flex-start;
        gap: 34px 54px ;
    }

    .section-loading{
        font-size: 30px;
        width:100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .section-loading div{
        padding-top: 50px;
    }
    .error{
        color: darkred;
    }
    /*@media (max-width: 650px) {*/
    /*    .controls{*/
    /*        flex-direction: column;*/
    /*    }*/
    /*}*/


</style>

<Window depth={depth} toFront={toFront} active={active} name="DROPS GALLERY"  minimise={minimise}>

    <div>
        <h1>
            Available DROPS
        </h1>
    </div>
    <div class="controls">
        <div class="slab">
            <h2>Drop type</h2>

            <div class="radio-options">
            {#each conditions as cond (cond.name)}
                <label>
                    <span class="radio-button">&nbsp;</span>
                    <input type=radio bind:group={condition} name="condition" value={cond.name}>
                    {cond.label}
                </label>
            {/each}
            </div>
        </div>
        
        <div  class="slab">
            <h2>Sort by</h2>
            <div class="radio-options">
                {#each sortModes[condition] as mode}
                    <label>
                        <span class="radio-button">&nbsp;</span>
                        <input type=radio bind:group={sortMode} name="condition" value={mode}>
                        {getSortModeLabel(mode)}
                    </label>
                {/each}
            </div>
        </div>

    </div>

        {#if _state !== "loaded"}
            {#if _state === "network"}
                <div class="section-loading error">
                    <div>Please connect to Ethereum mainnet.</div>
                </div>
            {:else if _state === "error"}
                <div class="section-loading  error">
                    <div >Web3 connection error.</div>
                </div>
            {:else }
                <div class="section-loading">
                    <div >Loading data...</div>
                </div>
            {/if}


        {:else}
            <div class="section-drops">
                    {#each sortedDrops as drop}
                        <DropListing drop={drop} openDrop={openDrop}/>
                    {/each}
            </div>
        {/if}

</Window>